module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar",
    attrs: {
      "id": "mainSidebar"
    }
  }, [_c('div', [_c('section', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "user-panel"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('p', {
    attrs: {
      "id": "greeting"
    }
  }, [_c('strong', [_vm._v("Welcome, " + _vm._s(_vm.first) + ".")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "rgba(0, 0, 0, 0.9)"
    }
  }, [_c('a', [_c('i', {
    staticClass: "ti-panel",
    on: {
      "click": _vm.goToSettings
    }
  }), _c('small', [_vm._v("Settings")])]), _c('a', [_c('i', {
    staticClass: "ti-user",
    on: {
      "click": _vm.goToProfile
    }
  }), _c('small', [_vm._v("Profile")])]), _c('a', [_c('i', {
    staticClass: "ti-power-off",
    on: {
      "click": _vm.handleLogout
    }
  }), _c('small', [_vm._v("Logout")])])])]), _vm._v(" "), _c('img', {
    staticClass: "bg-user",
    attrs: {
      "src": "https://cdn.aarp.net/content/dam/aarp/travel/tips/2020/11/1140-cars-on-highway.jpg",
      "alt": "User Image"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("Actions Hub")]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_c('router-link', {
    attrs: {
      "to": ""
    }
  }, [_c('i', {
    staticClass: "ti-car ",
    on: {
      "click": function($event) {
        return _vm.goToAccidents()
      }
    }
  }), _c('span', [_c('strong', [_c('small', [_vm._v("Manage Auto Accidents")])])]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/accidents/AccidentList"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Dashaboard One",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v("View Accidents")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/accidentInformationPage"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Dashaboard Two",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v("Report an Accident")], 1)], 1)])], 1), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_c('router-link', {
    attrs: {
      "to": ""
    }
  }, [_c('i', {
    staticClass: "ti-id-badge ",
    on: {
      "click": function($event) {
        return _vm.goToPolicies()
      }
    }
  }), _c('span', [_c('strong', [_c('small', [_vm._v("Manage Auto Insurance ")])])]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/policies/PolicyList"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v("View Insurance Policies")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/policies/addPolicy"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Dashaboard Two",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v("Add Insurance Policy")], 1)], 1)])], 1), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/gmap"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "GMaps API",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v(" GMaps API")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/open-layer"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "O P",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v("Open Layer")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/chart/chart-map"
    }
  }, [_c('avatar', {
    attrs: {
      "username": "Maps Vector",
      "size": 20,
      "color": "#fff"
    }
  }), _vm._v("Maps Vector")], 1)], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "overflow": "visible"
    }
  }, [_c('small', [_vm._v("Get auto-accident assistance here!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f790b8e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Sidebar.vue
// module id = 1304
// module chunks = 2